export default {
  title: 'Importa menu',
  master_title: 'Modalità marchio - Importa menu',
  buttons: {
    import: 'Importa',
  },
  toasts: {
    import: {
      pending:
        "⏳L'importazione può essere lenta, viene eseguita in background. Controlla il menu del ristorante tra qualche minuto.",
    },
  },
};
